export default __webpack_public_path__ + "static/media/printIcon.d920aff2.svg";